import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/lib/auth';
import { Shell } from '@/components/shell';
import { SignInPage } from '@/pages/sign-in';
import { DashboardPage } from '@/pages/dashboard';
import { AgentPage } from '@/pages/agent';
import { SystemHealthPage } from '@/pages/system-health';
import { ConnectorsPage } from '@/pages/connectors';
import { AnalyticsPage } from '@/pages/analytics';
import {
  AuditLogsPage, CustomersPage, InvoicesPage, OrdersPage, PaymentsPage, ProductsPage,
  ReturnsPage, UsersPage,
} from '@/pages/records';
import { Spinner } from '@/components/ui';
import { useLocale } from '@/i18n/locale-provider';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const { t } = useLocale();
  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <Spinner label={t.common.restoringSession} />
      </div>
    );
  }
  if (!user) return <Navigate to="/sign-in" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/sign-in" element={<SignInPage />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Shell>
                <Routes>
                  <Route index element={<DashboardPage />} />
                  <Route path="analytics" element={<AnalyticsPage />} />
                  <Route path="products" element={<ProductsPage />} />
                  <Route path="customers" element={<CustomersPage />} />
                  <Route path="orders" element={<OrdersPage />} />
                  <Route path="invoices" element={<InvoicesPage />} />
                  <Route path="payments" element={<PaymentsPage />} />
                  <Route path="returns" element={<ReturnsPage />} />
                  <Route path="agent" element={<AgentPage />} />
                  <Route path="connectors" element={<ConnectorsPage />} />
                  <Route path="users" element={<UsersPage />} />
                  <Route path="audit" element={<AuditLogsPage />} />
                  <Route path="system" element={<SystemHealthPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Shell>
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
